// jsdom では window.location を差し替えられないので、テストで mock できるよう切り出す
export function reloadPage(): void {
  window.location.reload();
}

export function goToLogin(): void {
  window.location.assign('/login');
}
